export enum CheckboxType {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
    WARNING = 'WARNING',
    DANGER = 'DANGER',
    DEFAULT = 'DEFAULT',
}
